export default __webpack_public_path__ + "static/media/logo.acb3d2b8.png";